import { render, staticRenderFns } from "./SuficienciaList.vue?vue&type=template&id=720ed721&"
import script from "./SuficienciaList.vue?vue&type=script&lang=js&"
export * from "./SuficienciaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports